"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareTab = exports.getUserOption = exports.getEmailOption = exports.GROUP = void 0;
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const Link_1 = __importDefault(require("@material-ui/icons/Link"));
const Gif_1 = __importDefault(require("@material-ui/icons/Gif"));
const StartAtInput_1 = require("./StartAtInput");
const utils_1 = require("./utils");
const shared_hooks_use_boolean_1 = require("@guidde-co/shared.hooks.use-boolean");
const shared_spaced_group_1 = require("@guidde-co/shared.spaced-group");
const shared_white_button_1 = require("@guidde-co/shared.white-button");
const useStyles = (0, core_1.makeStyles)({
    disabled: {
        backgroundColor: '#CB0000 !important',
        opacity: 0.4,
        color: '#FFFFFF !important'
    },
    endAdornment: {
        top: '-16px !important',
        right: '8px'
    },
    greyLine: {
        position: 'absolute',
        bottom: '-1px',
        left: 0,
        right: 0,
        background: '#fff',
        height: '5px',
        width: '100%'
    },
    redLine: {
        position: 'absolute',
        bottom: '-4px',
        left: 0,
        right: 0,
        background: '#cb0000',
        height: '1px',
        width: 'calc(100% + 20px)',
        transform: 'translateX(-10px)'
    },
    chip: {
        color: '#090C10',
        fontSize: 14,
        background: 'rgba(9, 12, 16, 0.08)',
        border: '1px solid rgba(9, 12, 16, 0.08)',
        borderRadius: 16,
        height: '24px !important'
    }
});
exports.GROUP = {
    spaces: 'Spaces',
    teamMembers: 'Team Members',
    externalMembers: 'External Members',
    pendingEmails: 'Pending Emails'
};
const getEmailOption = (user) => (Object.assign(Object.assign({}, (0, utils_1.option)(user.email, user.email)), { isSelected: user.isSelected, group: exports.GROUP.pendingEmails, email: user.email, name: '', logo: '' }));
exports.getEmailOption = getEmailOption;
const getUserOption = (user) => (Object.assign(Object.assign({}, (0, utils_1.option)(user.uid, user.email)), { isSelected: user.isSelected, group: exports.GROUP.teamMembers, email: user.email, name: user.displayName, logo: user.logo }));
exports.getUserOption = getUserOption;
exports.ShareTab = (0, react_1.memo)(({ currentTime, options, playbook, hideCopyLink, steps = [], onShare, isLoading, copyLinkPath, uid, onCopySharedLink, onCopyGifLink }) => {
    const classes = useStyles();
    const startAt = (0, shared_hooks_use_boolean_1.useBoolean)();
    const focussed = (0, shared_hooks_use_boolean_1.useBoolean)();
    const [startTime, setStartTime] = (0, react_1.useState)('00:00:00');
    (0, react_1.useEffect)(() => {
        setStartTime((0, utils_1.generateStartValue)(currentTime));
    }, [currentTime]);
    const isQG = playbook.mode === 'quickGuidde';
    const optionsList = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        return [
            ...(((_a = options === null || options === void 0 ? void 0 : options.internalUsers) === null || _a === void 0 ? void 0 : _a.map(exports.getUserOption)) || []),
            ...(((_b = options === null || options === void 0 ? void 0 : options.externalUsers) === null || _b === void 0 ? void 0 : _b.map(exports.getUserOption)) || []),
            ...(((_c = options === null || options === void 0 ? void 0 : options.pendingEmails) === null || _c === void 0 ? void 0 : _c.map(exports.getEmailOption)) || [])
        ];
    }, [options]);
    return (react_1.default.createElement(core_1.Box, { p: 2 },
        react_1.default.createElement(StartAtInput_1.StartAtInput, { startAt: startAt, startTime: startTime, setStartTime: setStartTime }),
        react_1.default.createElement(shared_spaced_group_1.SpacedGroup, { width: "100%", mt: 2, spacing: 3 },
            !hideCopyLink && (react_1.default.createElement(shared_white_button_1.WhiteButton, { startIcon: react_1.default.createElement(Link_1.default, null), fullWidth: true, color: "primary", onClick: () => {
                    (0, utils_1.copyToClipboard)(`${window.location.origin}${copyLinkPath}?origin=${uid}${startAt.isTrue
                        ? `&t=${(0, utils_1.timeToSeconds)(startTime)}`
                        : ''}`).then(onCopySharedLink);
                } }, "COPY LINK")),
            react_1.default.createElement(shared_white_button_1.WhiteButton, { startIcon: react_1.default.createElement(Gif_1.default, null), style: { width: hideCopyLink ? '25%' : '100%' }, color: "default", onClick: () => {
                    (0, utils_1.copyLinkedGif)({
                        copyLinkPath,
                        uid,
                        playbook,
                        isQuickGuidde: playbook.mode === 'quickGuidde'
                    }).then(onCopyGifLink);
                } }, "COPY GIF")),
        react_1.default.createElement(core_1.Box, { mt: 4 }),
        react_1.default.createElement(formik_1.Formik, { initialValues: {
                options: optionsList.filter(it => it.isSelected)
            }, enableReinitialize: true, onSubmit: ({ options }) => {
                const filteredEmails = options.filter(({ group }) => group === exports.GROUP.pendingEmails);
                // we have empty list is user is Anonymous
                const emails = optionsList.length > 0 ? filteredEmails : options;
                onShare({
                    emails: emails.map(o => o.value),
                    userIds: options
                        .filter(({ group }) => group === exports.GROUP.teamMembers)
                        .map(o => o.value)
                });
            } }, ({ dirty, values, setFieldValue }) => (react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement(lab_1.Autocomplete, { multiple: true, value: values.options, onChange: (e, value) => {
                    if (value.every(it => typeof it === 'object')) {
                        setFieldValue('options', value);
                    }
                    else {
                        const modifiedValue = value.map(it => {
                            if (typeof it === 'object')
                                return it;
                            return {
                                value: it,
                                label: it,
                                isSelected: false,
                                group: exports.GROUP.pendingEmails
                            };
                        });
                        setFieldValue('options', modifiedValue);
                    }
                }, onFocus: focussed.setTrue, onBlur: focussed.setFalse, freeSolo: true, options: optionsList, getOptionLabel: option => option.label, filterSelectedOptions: true, style: {
                    background: '#FFFFFF',
                    padding: `${values.options.length < 1 ? 0 : 8}px 8px 4px`,
                    marginTop: values.options.length < 1 ? '-10px' : 0,
                    borderRadius: '4px 4px 0 0',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    maxHeight: '200px'
                }, classes: {
                    endAdornment: classes.endAdornment
                }, renderTags: (params, getProps) => {
                    return params.map((it, index) => (react_1.default.createElement(core_1.Chip, Object.assign({ label: it.name || it.email || it.value, key: it.value, classes: { root: classes.chip }, deleteIcon: react_1.default.createElement(Close_1.default, { fontSize: "small", style: {
                                width: 15,
                                height: 15,
                                color: '#090C10',
                                marginRight: 5
                            } }) }, getProps({ index })))));
                }, renderOption: params => (react_1.default.createElement(shared_spaced_group_1.SpacedGroup, null,
                    react_1.default.createElement(core_1.Avatar, { src: params.logo, style: { width: 40, height: 40 } }),
                    react_1.default.createElement(core_1.Box, null,
                        react_1.default.createElement(core_1.Typography, { style: {
                                fontSize: 14,
                                fontWeight: 500
                            } }, params.name),
                        react_1.default.createElement(core_1.Typography, { color: "textSecondary", style: { fontSize: 14 } }, params.email)))), renderInput: params => (react_1.default.createElement(core_1.Box, { position: "relative" },
                    react_1.default.createElement(core_1.TextField, Object.assign({}, params, { style: {
                            textAlign: 'center',
                            color: 'rgba(0, 0, 0, 0.54)  !important'
                        }, label: react_1.default.createElement(core_1.Box, { color: focussed.isTrue
                                ? 'inherit'
                                : 'rgba(0, 0, 0, 0.54) !important', mt: "-3px", fontSize: focussed.isTrue
                                ? 'inherit'
                                : '14px' }, "Send email") })),
                    react_1.default.createElement(core_1.Box, { className: classes.greyLine }),
                    focussed.isTrue && (react_1.default.createElement(core_1.Box, { className: classes.redLine })))) }),
            react_1.default.createElement(core_1.Box, { mt: 2, display: "flex", justifyContent: "flex-end", width: "100%" },
                react_1.default.createElement(core_1.Button, { type: "submit", disabled: !dirty || isLoading, color: "primary", className: !dirty || isLoading
                        ? classes.disabled
                        : '' }, "SEND")))))));
});
//# sourceMappingURL=ShareTab.js.map